// Helpers for displaying an installed device's structured location (Building › Floor › Room).

export interface StructuredLocationLabels {
	buildingName?: string | null;
	floorName?: string | null;
	roomName?: string | null;
}

// Anything that carries the location relationships (real installed_products rows) or plain
// name fields. Both `building { name }` and a flat `buildingName` are accepted.
interface LocationSource {
	building?: { name?: string | null } | null;
	floor?: { name?: string | null } | null;
	room?: { name?: string | null } | null;
	buildingName?: string | null;
	floorName?: string | null;
	roomName?: string | null;
}

/** Pull the three level names from a row that has `building/floor/room { name }` relationships. */
export const labelsFromRelationships = (source?: LocationSource | null): StructuredLocationLabels => ({
	buildingName: source?.building?.name ?? source?.buildingName ?? null,
	floorName: source?.floor?.name ?? source?.floorName ?? null,
	roomName: source?.room?.name ?? source?.roomName ?? null
});

/**
 * Human-readable "Building › Floor › Room" path, including only the levels that are set.
 * Returns null when no structured level is present.
 */
export const formatStructuredLocation = (labels?: StructuredLocationLabels | null): string | null => {
	if (!labels) return null;
	const parts = [labels.buildingName, labels.floorName, labels.roomName].filter(Boolean) as string[];
	return parts.length ? parts.join(" › ") : null;
};
